import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"fileUp\"><g id=\"Group 549\"><path id=\"Vector\" d=\"M14.7 3H6.60005C6.12266 3 5.66482 3.18964 5.32726 3.52721C4.98969 3.86477 4.80005 4.32261 4.80005 4.8V19.2C4.80005 19.6774 4.98969 20.1352 5.32726 20.4728C5.66482 20.8104 6.12266 21 6.60005 21H17.4C17.8774 21 18.3353 20.8104 18.6728 20.4728C19.0104 20.1352 19.2 19.6774 19.2 19.2V7.5L14.7 3Z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M13.8003 3V6.6C13.8003 7.07739 13.9899 7.53523 14.3275 7.87279C14.6651 8.21036 15.1229 8.4 15.6003 8.4H19.2003\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_3\" d=\"M12.0002 12V17.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_4\" d=\"M14.7003 14.7L12.0003 12L9.30029 14.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }